import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51eb4704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionsView" }

import { onMounted, ref, watchEffect } from "vue";
import {
  Question,
  QuestionControllerService,
  QuestionQueryRequest,
} from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionsView',
  setup(__props) {

const router = useRouter();

const show = ref(true);

const dataList = ref([]);
const total = ref(0);
const searchParas = ref<QuestionQueryRequest>({
  // 查询条件
  title: "",
  tags: [],
  pageSize: 10, // 每页题目数
  current: 1,
});

/**
 *  分页获取 题目数据
 */
const loadData = async () => {
  const res = await QuestionControllerService.listQuestionVoByPageUsingPost(
    searchParas.value
  );
  console.log(res.data);
  // 查询结果为0
  if (res.code === 0) {
    dataList.value = res.data.records; // 数据条数
    total.value = res.data.total; // 数据总数
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 *  页面加载时 请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "题号",
    dataIndex: "id",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tags",
  },
  {
    title: "通过率",
    slotName: "ACRate",
  },
  {
    title: "创建时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

/**
 * 监听函数loadData
 *  若函数中有变量改变，程序执行该函数
 *   用于分页，当searchParas改变时，重新加载页面
 */
watchEffect(() => {
  loadData();
});

// 分页时更新页号
const onPageChange = (page: number) => {
  searchParas.value = {
    ...searchParas.value,
    current: page,
  };
};

/**
 *  跳转题目详情页
 * @param question
 */
const toQuestionPage = (question: Question) => {
  // 路由跳转 get传id
  router.push({
    path: `/detail/question/${question.id}`,
  });
};

/**
 *  题目模糊搜索
 *    搜索是对search修改，提交时 触发自动刷新
 */
const doSearch = () => {
  searchParas.value = {
    ...searchParas.value,
    current: 1, // 页号恢复到第一页
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      class: "search",
      model: searchParas.value,
      layout: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题",
          style: {"min-width":"280px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParas.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParas.value.title) = $event)),
              placeholder: "请输入题目名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tags",
          label: "标签",
          style: {"min-width":"280px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: searchParas.value.tags,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParas.value.tags) = $event)),
              placeholder: "请输入标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: doSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParas.value.pageSize,
        current: searchParas.value.current,
        total: total.value,
      },
      onPageChange: onPageChange,
      style: {"margin":"0 20px"}
    }, {
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      ACRate: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(`${
            parseFloat(
              record.submitNum ? record.acceptedNum / record.submitNum : "0"
            ).toFixed(4) * 100
          }% (${record.acceptedNum}/${record.submitNum})`), 1)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (toQuestionPage(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})